var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a, _b;
import { Action, Mutation, Module, VuexModule } from "vuex-module-decorators";
import { Actions, Mutations } from "@/store/enums/StoreEnums";
let BreadcrumbsModule = class BreadcrumbsModule extends VuexModule {
    constructor() {
        super(...arguments);
        this.breadcrumbs = {};
    }
    /**
     * Get breadcrumb object for current page
     * @returns object
     */
    get getBreadcrumbs() {
        return this.breadcrumbs;
    }
    /**
     * Get breadcrumb array for current page
     * @returns object
     */
    get pageBreadcrumbPath() {
        return this.breadcrumbs.pageBreadcrumbPath;
    }
    /**
     * Get current page title
     * @returns string
     */
    get pageTitle() {
        return this.breadcrumbs.title;
    }
    [_a = Mutations.SET_BREADCRUMB_MUTATION](payload) {
        this.breadcrumbs = payload;
    }
    [_b = Actions.SET_BREADCRUMB_ACTION](payload) {
        this.context.commit(Mutations.SET_BREADCRUMB_MUTATION, payload);
    }
};
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], BreadcrumbsModule.prototype, _a, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], BreadcrumbsModule.prototype, _b, null);
BreadcrumbsModule = __decorate([
    Module
], BreadcrumbsModule);
export default BreadcrumbsModule;
